import { createFileRoute } from "@tanstack/react-router";
import AiPolicyPage from "@/pages/security/AiPolicyPage";

export const Route = createFileRoute("/security/ai-policy")({
  component: AiPolicyPage,
});
